import Controller from '@ember/controller';
import { action } from '@ember/object';
import DeliveryModel from 'cio/models/delivery';
import DeliveryDetailModel from 'cio/models/delivery-detail';

export default class DraftController extends Controller {
  declare model: DeliveryModel;

  get deliveryDetail() {
    return this.model.belongsTo('detail').value() as DeliveryDetailModel;
  }

  @action
  rollbackDraft() {
    this.deliveryDetail?.rollbackAttributes();
  }
}
